module.exports = __webpack_public_path__ + "img/workout_placeholder_icon.b1180c23.png";